import { match } from '@st/pattern'
import type { ReactNode } from 'react'
import { Button, Dialog, DialogButtons } from '@st/theme'

// Shared form chrome only. Each editor owns its fields and validation.
export function ChecklistEditDialog({
  editing,
  subtitle,
  valid = true,
  onSave,
  onClose,
  children
}: {
  editing: boolean
  subtitle?: string
  valid?: boolean
  onSave: () => void
  onClose: () => void
  children: ReactNode
}) {
  return (
    <Dialog
      subtitle={subtitle}
      title={match(editing)
        .with(true, () => 'Edit checklist item')
        .with(false, () => 'Add checklist item')
        .exhaustive()}
      className="max-h-svh w-full"
      buttons={
        <DialogButtons>
          <Button variant="subtle" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSave} disabled={!valid}>
            Save item
          </Button>
        </DialogButtons>
      }
    >
      <div className="space-y-5">{children}</div>
    </Dialog>
  )
}

export function ChecklistNote({
  value,
  onChange
}: {
  value: string
  onChange: (value: string) => void
}) {
  return (
    <label className="flex flex-col gap-2 text-sm text-gray-700">
      Note
      <textarea
        rows={4}
        className="w-full rounded-md border-gray-300 text-base text-gray-900 focus:border-blue-500 focus:ring-blue-500"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
  )
}
